<template>
	<div id="wrapper">
		<div class="header">
			<img src="../statics/img/logo.svg" v-if="!isChPage" />
			<img src="/themes/fc-schaffhausen/logo.png" v-else />
			<h2>Check-Out</h2>
		</div>
		<!-- scanner -->
		<div v-if="!isDone" class="scanner" :class="{ 'scanner--resolved': isQrCodeResolved, 'scanner--invalid': isInvalidResult }">
			<div class="scanner__inner">
				<!-- corners -->
				<div class="scanner__corner scanner__corner--tl"></div>
				<div class="scanner__corner scanner__corner--tr"></div>
				<div class="scanner__corner scanner__corner--bl"></div>
				<div class="scanner__corner scanner__corner--br"></div>

				<!-- video -->
				<div v-if="isLoading" class="three-bounce">
					<div class="one"></div>
					<div class="two"></div>
					<div class="three"></div>
				</div>
				<div v-else>
					<video id="qr-video" muted playsinline class="scanner__camera"></video>
				</div>
			</div>

			<div class="scanner__input">
				Bitte halten Sie Ihren QR-Code vor den Scanner.
			</div>

			<span v-if="isInvalidResult" class="validation-message">Gescannter Code ist ungültig</span>
		</div>

		<!-- result -->
		<template v-else>
			<div class="btn" @click="newScan()">Neuer Scan ({{ countDown }})</div>
			<div :class="scanResultCssClass">
				<h2 v-if="!scanResult.IsValid && scanResult.Message">
					<i class="fad fa-check-circle"></i>
					{{ scanResult.Message }}<br />
					<div>Code: '{{ scanResult.Data.Code }}'</div>
				</h2>
				<h2 v-else>
					<i class="fad fa-check-circle"></i>
					Ticket wurde erfolgreich ausgechecked.<br />
					<div>Code: '{{ scanResult.Data.Code }}'</div>
				</h2>
			</div>
		</template>
	</div>
</template>

<script>
	import scanMixin from '../mixins/_scan.js';

	export default {
		name: "check-out",
		mixins: [scanMixin],
		data() {
			return {
				countDownTimerInterval: null,
				countDownSeconds: 4
			};
		}
	};
</script>